const translations = {
  monday_short: 'Mon',
  tuesday_short: 'Tue',
  wednesday_short: 'Wed',
  thursday_short: 'Thu',
  friday_short: 'Fri',
  saturday_short: 'Sat',
  sunday_short: 'Sun',

  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Fridat',
  saturday: 'Saturday',
  sunday: 'Sunday',

  this_week: 'This week',
  this_month: 'This month',
  last_month: 'Last month'
};

export default translations;